/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import * as Yup from "yup";
import {
  DescriptionInputComponent,
  TextInputComponent,
} from "../../../../common/components";
import { Formik, Form } from "formik";
import LeadCaptureFormElements from "./create-lead-capture-form-elements";
import "./create-lead-capture-form.scss";
import { useLogin } from "../../../../common/hooks/useUser";
import EmailSetUpBanner from "../../../../common/components/email-setup-required-banner/email-setup-banner";

const CreateLeadCaptureFormPreview = (props: any) => {
  const {
    columns,
    formName,
    setIsShowCancelPopup,
    handleSavePreview,
    subject,
    setSubject,
    type,
    setType,
    isViewMode,
    isResponseViewMode,
    handleClosePreview,
  } = props;
  const formikRef = React.useRef(null);
  const loginDetails = useLogin();
  const isEmailConfigured = loginDetails?.isEmailConfigured;

  return (
    <>
      <div className="lead-capture-preview">
        {!isEmailConfigured && !isViewMode && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <EmailSetUpBanner />
          </div>
        )}
        <Formik
          initialValues={{
            subject: subject,
            type: type,
          }}
          innerRef={formikRef}
          enableReinitialize={true}
          initialTouched={{ subject: true, type: true }}
          validateOnChange={true}
          validationSchema={Yup.object().shape({
            type: Yup.string().required("Type cannot be empty"),
            subject: Yup.string().required("Subject cannot be empty"),
          })}
          onSubmit={() => {}}
        >
          {({ setFieldValue, validateForm, isValid }) => (
            <Form>
              <div className="lead-capture-preview-section">
                <div className="lead-capture-preview-section-right">
                  <div className="lead-capture-preview-section-right-element">
                    <TextInputComponent
                      type="text"
                      fieldName="subject"
                      placeholder="Enter Subject"
                      optional={false}
                      disabled={isViewMode}
                      value={subject}
                      onChange={(e: any) => {
                        setSubject(e?.target?.value);
                        setFieldValue("subject", e?.target?.value);
                      }}
                      maxlength="500"
                    />
                  </div>
                  <div className="lead-capture-preview-section-right-element">
                    <DescriptionInputComponent
                      fieldName="type"
                      placeholder="Type"
                      optional={false}
                      disabled={isViewMode}
                      value={type}
                      onChange={(e: any) => {
                        setType(e?.target?.value);
                        setFieldValue("type", e?.target?.value);
                      }}
                      maxlength={150}
                    />
                  </div>
                </div>
                <div className="lead-capture-preview-section-left">
                  <div className="lead-capture-preview-section-left-title">
                    {formName}
                  </div>

                  <div className="lead-capture-preview-section-left-form">
                    <div className="lead-capture-preview-section-left-form-subtitle">
                      <div className="lead-capture-preview-section-left-subtitle">
                        Primary Information
                      </div>
                      {columns?.sub?.list?.map((data: any, index: number) =>
                        data?.title !== "address" ? (
                          <div
                            className="lead-capture-preview-section-left-form-element"
                            style={isViewMode ? { pointerEvents: "none" } : {}}
                            key={index}
                          >
                            <LeadCaptureFormElements data={data} />
                          </div>
                        ) : null
                      )}
                    </div>
                    <div className="lead-capture-preview-section-left-form-subtitle lead-capture-preview-section-left-form-subtitle-address">
                      {columns?.sub?.list?.map((data: any, index: number) =>
                        data?.title === "address" ? (
                          <div
                            className="lead-capture-preview-section-left-form-element"
                            style={isViewMode ? { pointerEvents: "none" } : {}}
                            key={index}
                          >
                            <LeadCaptureFormElements data={data} />
                          </div>
                        ) : null
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="lead-capture-preview-section-bottom">
                <div className="lead-capture-preview-section-bottom-left">
                  <div className="lead-capture-preview-section-bottom-left-element">
                    {!isViewMode ? (
                      <button
                        type="button"
                        className="lead-capture-preview-section-bottom-left-reset-button"
                        onClick={() => setIsShowCancelPopup(true)}
                      >
                        Cancel
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="lead-capture-preview-section-bottom-left-reset-button"
                        onClick={() => handleClosePreview()}
                      >
                        Close
                      </button>
                    )}
                  </div>
                </div>
                <div className="lead-capture-preview-section-bottom-right">
                  <div className="lead-capture-preview-section-bottom-right-element">
                    {!isViewMode ? (
                      <button
                        type="button"
                        className="lead-capture-preview-section-bottom-right-reset-button"
                        onClick={() => {
                          validateForm();
                          if (!isValid) {
                            return;
                          }
                          if (type && subject) {
                            handleSavePreview(false, formikRef);
                          }
                        }}
                      >
                        Save
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="lead-capture-preview-section-bottom-right-element">
                    {!isResponseViewMode ? (
                      <button
                        type="button"
                        className="lead-capture-preview-section-bottom-right-save-button"
                        onClick={() => {
                          validateForm();
                          if (!isValid) {
                            return;
                          }
                          if (type && subject) {
                            handleSavePreview(true, formikRef);
                          }
                        }}
                        disabled={!isEmailConfigured}
                      >
                        Save & Share
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default CreateLeadCaptureFormPreview;
